import Icon from '../../components/Icon.vue'

Icon.register({"brands/viacoin":{"width":384,"height":512,"paths":[{"d":"M384 32H320L239.3 224H144.8L64 32H0L48 144H0V192H68.5L82.3 224H0V272H102.8L192 480 281.2 272H384V224H301.7L315.5 192H384V144H336L384 32zM192 336L165 272H219L192 336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/viacoin.js
// module id = null
// module chunks = 